import { AuditStatus } from "@/lib/shopConfigAudit";

export type StatusStyle = {
  dot: string;
  tile: string;
  tileValue: string;
  tileLabel: string;
  chip: string;
  valuePill: string;
  listChip: string;
};

// The one place audit status colors live. Values are the mockup's exact
// colors as arbitrary-value classes: `green` is a flat Tailwind color in this
// repo (numbered green-* classes compile to nothing) and the app shell makes
// uncolored text near-white, so every status carries explicit text + bg.
export const STATUS_STYLES: Record<AuditStatus, StatusStyle> = {
  missing: {
    dot: "bg-destructive",
    tile: "bg-[#fee2e2]",
    tileValue: "text-[#b91c1c]",
    tileLabel: "text-[#7f1d1d]",
    chip: "bg-[#fee2e2] text-[#b91c1c]",
    valuePill:
      "rounded border border-dashed border-[#f87171] px-2 py-px text-xs font-semibold text-[#b91c1c]",
    listChip:
      "rounded-full border border-dashed border-[#f87171] px-2.5 py-[3px] text-xs font-medium text-[#b91c1c]",
  },
  drift: {
    dot: "bg-warning",
    tile: "bg-[#fef3c6]",
    tileValue: "text-[#92400e]",
    tileLabel: "text-[#78350f]",
    chip: "bg-[#fef3c6] text-[#92400e]",
    valuePill:
      "rounded bg-[#fef3c6] px-2 py-px text-xs font-semibold text-[#92400e]",
    listChip:
      "rounded-full bg-[#fef3c6] px-2.5 py-[3px] text-xs font-medium text-[#92400e]",
  },
  match: {
    dot: "bg-success",
    tile: "bg-[#dcfce7]",
    tileValue: "text-[#15803d]",
    tileLabel: "text-[#14532d]",
    chip: "bg-[#dcfce7] text-[#15803d]",
    valuePill: "text-[13px] text-[#15803d]",
    listChip:
      "rounded-full bg-[#dcfce7] px-2.5 py-[3px] text-xs font-medium text-[#15803d]",
  },
};
